import { ApplicationBookingState } from '@flatsy/types/Applications'
import { getLatestData } from '../Utils/GetLatestData'
import { WizardContext, WizardEvent } from '../wizardMachine'

export const hasBooking = (context: WizardContext, event: WizardEvent): boolean => {
  const { application } = getLatestData(context, event)
  if (application) {
    return (
      application.booking_state === ApplicationBookingState.CONFIRMED ||
      application.booking_state === ApplicationBookingState.COMPLETED
    )
  }
  return false
}
